import { render, staticRenderFns } from "./MarketingEmailConfigModal.vue?vue&type=template&id=3d17a16d&scoped=true"
import script from "./MarketingEmailConfigModal.vue?vue&type=script&lang=js"
export * from "./MarketingEmailConfigModal.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailConfigModal.vue?vue&type=style&index=0&id=3d17a16d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d17a16d",
  null
  
)

export default component.exports